// extracted by mini-css-extract-plugin
export default {"imageWrapper":"JD-z","hovered":"KD-z","hoverImage":"LD-z","mainImage":"MD-z","imageNoBackground":"ND-z","fullSizeImage":"OD-z"};